module.exports = __webpack_public_path__ + "static/nilupak-32d762f33efc1e6b39e8812ae8971faf.jpg";